import { render, staticRenderFns } from "./CourseStatistic.vue?vue&type=template&id=10690cce&"
import script from "./CourseStatistic.vue?vue&type=script&lang=js&"
export * from "./CourseStatistic.vue?vue&type=script&lang=js&"
import style0 from "./CourseStatistic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports